module.exports = __webpack_public_path__ + "assets/logo-2e70ad.png";